import { BadgeVariant } from '@components/Badge/types'
import { styled } from 'parkdepot-shared/theme'

export const Container = styled('div', ({ $theme }) => ({
    padding: '2rem 3rem',
    borderRadius: '1.4rem',
    border: `1px solid #B3BBC7`,
    cursor: 'pointer'
}))

export const HeaderWrapper = styled('div', ({ $theme }) => ({
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: '2.6rem'
}))

export const CardType = styled('span', ({ $theme }) => ({
    fontSize: '1.2rem',
    fontWeight: 300,
    lineHeight: '1.8rem',
    color: $theme.colors.black
}))

export const ContentWrapper = styled('div', ({ $theme }) => ({
    display: 'flex',
    justifyContent: 'space-between'
}))

export const LotName = styled('span', ({ $theme }) => ({
    fontSize: '1.4rem',
    fontWeight: 700,
    lineHeight: '2rem',
    color: $theme.colors.black
}))

export const DataText = styled('p', ({ $theme }) => ({
    fontSize: '1.2rem',
    fontWeight: 300,
    lineHeight: '1.8rem',
    display: 'flex',
    flexDirection: 'column',
    gap: '0.4rem',
    margin: '0.4rem 0'
}))

// future;information  - #9AA1FF
// past;default - #B3BBC7
// aktiv;positive - #6EE998
export const RepeatCircle = styled<'div', { $type: BadgeVariant }>('div', ({ $theme, $type }) => ({
    width: '4.5rem',
    height: '4.5rem',
    borderRadius: '50%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    transform: 'rotate(45deg)',
    backgroundColor: $type === 'information' ? '#9AA1FF' : $type === 'default' ? '#B3BBC7' : '#6EE998'
}))

export const RepeatIcon = styled('i', ({ $theme }) => ({
    fontSize: '2rem',
    color: '#fff'
}))
